'use strict'
import ShoppingCart from "../../components/shopping-cart/ShoppingCart";

class AuthClass {
  
  constructor(){
      this._access_token = false;
      
      this._user = false;

      this._refreshInterval = null;

      this._sessionReadyCallbacks = [];
  }
  
  initSession(){
    this._refreshToken()
    .then(() => this._getLoggedUser())
    .then((data)=>{
      this._user = data;
      
      this._sessionReadyCallbacks.forEach(callback => {
        callback(true);
      })
      
      // llamar al refresh_cada 30 segundos luego d ela primer vez
      this._refreshInterval = setInterval(()=>{
        this._refreshToken(); 
      }, 30000);
    })
    .catch(() => {
      // Ejecuto callbacks para que no queden pending
      this._sessionReadyCallbacks.forEach(callback => {
        callback(false);
      })
    })
    .finally(()=>{
      // Agrego un listener a storage para poder saber si se desloguea o se loguea
      window.addEventListener('storage', this._onStorageChange.bind(this));
    })
  }
  
  addEventListener(event, callback){
    switch(event){
      case 'sessionReady':
        this._sessionReadyCallbacks.push(callback);
      break;  
    }
  }

  get user(){
    return this._user;
  }
  
  get isUserLogged(){
    return this._user != false;
  }

  get isCustomerLogged(){
    return this._user && this._user.type == 'customer';
  }

  get isExternalSellerLogged(){
    return this._user && this._user.type == 'external' && this._user.role == 'seller';
  }

  get isInternalLogged(){
    return this._user && this._user.type == 'internal';
  }

  get isInternalTrafficManagerLogged(){
    return this._user && this._user.type == 'internal'  && this._user.role == 'traffic-manager';
  }

  get isInternalTrafficCoordinatorLogged(){
    return this._user && this._user.type == 'internal'  && this._user.role == 'traffic-coordinator';
  }

  get isInternalStaticOperatorManagerLogged(){
    return this._user && this._user.type == 'internal'  && this._user.role == 'static-operator-manager';
  }

  get isInternalStaticOperatorLogged(){
    return this._user && this._user.type == 'internal'  && this._user.role == 'static-operator';
  }

  get isInternalSellerLogged(){
    return this._user && this._user.type == 'internal' && this._user.role == 'seller';
  }
  get isInternalSalesManagerLogged(){
    return this._user && this._user.type == 'internal' && this._user.role == 'sales-manager';
  }

  get isInternalSalesAssistantLogged() {
    return this._user && this._user.type == 'internal' && this._user.role == 'sales-assistant';
  }

  login(email, password){
    let requestData = {
      email: email,
      password: password
    }
    
    return fetch(`${BASE_URL}api/auth/login`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(requestData)
    })
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject)=>{
        if(response.error){
          reject(response.data)
        }else{
          window.localStorage.setItem('auth_status_change', Date.now());
  
          this.initSession();
  
          resolve(response.data)
        }
      })
    })
  }

  loginV2(email, password){
    let requestData = {
      email: email,
      password: password
    }
    
    return fetch(`${BASE_URL}api/auth/login`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(requestData)
    })
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject)=>{
        if(response.error){
          reject(response.data)
        }else{
          window.localStorage.setItem('auth_status_change', Date.now());
  
          this.initSession();
  
          resolve(response.data)
        }
      })
    })
  }

  loginAs(userId, accessToken){
  
    return fetch(`${BASE_URL}api/auth/login-as/${userId}`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject)=>{
        if(response.error){
          reject(response.data)
        }else{
          window.localStorage.setItem('auth_status_change', Date.now());
  
          this.initSession();
  
          resolve(response.data)
        }
      })
    })
  }

  logout()
  {
    fetch(`${BASE_URL}api/auth/logout`,{
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
    })
      .then((response) => {return response.json()})
      .then((response)=>{
        ShoppingCart.clear();
        // notificamos a las otras ventanas/tabs
        window.localStorage.setItem('auth_status_change', Date.now());
        
        clearInterval(this._refreshInterval);
        
        // Redirect to login page
        window.location = `${BASE_URL}login`;
    });
  }

  _onStorageChange(e){
    if(!document.hasFocus() && e.key == 'auth_status_change'){
      window.location.reload();
    }
  }
  
  _refreshToken()
  {
    return fetch(`${BASE_URL}api/auth/refresh`,{
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
    })
    .then((response) => {return response.json()})
    .then((response)=>{
      if(response.error){
        return Promise.reject();
      
      }else{
        // Lo Guardamos para futuros llamados
        this._access_token = response.access_token;
        // console.log('guarda access token');
        return true;
      }
    }).catch(() => {
      if (['internal', 'customer'].includes(window.location.pathname.split('/')[2])) {
        window.location.href = `${BASE_URL}login`;
      }
    });
  }

  _getLoggedUser()
  {
    return this.makePrivateGet(`${BASE_URL}api/auth/me`);
  }



  // Actualiza el password del usuario loggeado
  resetPassword(newPassword)
  {
    let params = {
      new_password: newPassword
    };
    
    return Auth.makePrivatePut(`${BASE_URL}api/auth/reset-password`, params)
  }


  // Actualiza el password del usuario NO loggeado
  resetPasswordForgotten(newPassword, accessToken){
    let params = {
      new_password: newPassword
    };
    
    let options = {
      method: 'put',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(params)
    };
    
    return fetch(`${BASE_URL}api/auth/reset-password/${accessToken}`, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  forgotPassword(email){
    let requestData = {
      email: email
    }
    
    return fetch(`${BASE_URL}api/auth/forgot-password`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(requestData)
    })
    .then((response) => {return response.json()})
    .then((response) => {
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  register(params){    
    let options = {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(params)
    };
    
    return fetch(`${BASE_URL}api/auth/register`, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  registerResendEmail(email, accessToken, redirect){
    const requestData = {
      email: email,
      redirect: redirect,
    }

    return fetch(`${BASE_URL}api/auth/register/resend-email/${accessToken}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify(requestData)
    })
    .then((response) => {return response.json()})
    .then((response) => {
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  isValidPassword(password) {
    const validations = {
      'length': password.length >= 8,
      'letter': /[a-zA-Z]/.test(password),
      'number': /[0-9]/.test(password),
      'symbol': /[^A-Za-z0-9]/.test(password)
    };

    let errorMessage = 'Must have at least ';

    if (!validations.length) {
      errorMessage += '8 characters, ';
    }

    if (!validations.letter) {
      errorMessage += 'one letter, ';
    }

    if (!validations.number) {
      errorMessage += 'one number, ';
    }

    if (!validations.symbol) {
      errorMessage += 'one symbol, ';
    }

    errorMessage = errorMessage.replace(/, $/, '');

    return {
      'isValid': /[a-zA-Z]/.test(password) && /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password) && password.length >= 8,
      validations,
      errorMessage
    };
  }
  
  makePrivateGet(url)
  {
    let options = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      }
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  makePrivateBlobGet(url)
  {
    let options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      }
    };
    
    return fetch(url, options).then(function (response) {
        if (response.ok) {
            return response.blob();
        } else {
            return response.json()
              .then(function (myJson) {
                  return Promise.reject(myJson);
              });
        }
      }
    );
  }

  makePrivateBlobPost(url, params)
  {
    let options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };
    
    return fetch(url, options).then(function (response) {
        if (response.ok) {
            return response.blob();
        } else {
            return response.json()
              .then(function (myJson) {
                  return Promise.reject(myJson);
              });
        }
      }
    );
  }  

  makePrivatePost(url, params)
  {
    let options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  makePrivatePostWithStatus(url, params)
  {
    let options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };

    return fetch(url, options)
    .then(response => response.json().then(data => ({
          data: data,
          status: response.status
        })
      )
    )
    .then((response) => {
      return new Promise((resolve, reject) => {
        if (response.data.error) {
          reject(response);
        } else {
          resolve(response);
        }
      });
    });
  }

  makePrivateDelete(url, params)
  {
    let options = {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  makePrivateFormDataPost(url, formData, signal = null)
  {
    let options = {
      method: 'POST',
      signal: signal,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: formData
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  makePrivatePut(url, params)
  {
    let options = {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }

  makePrivatePatch(url, data) {
    let options = {
      method: 'PATCH',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(data)
    };

    return fetch(url, options)
      .then((response) => { return response.json() })
      .then((response) => {
        return new Promise((resolve, reject) => {
          if (response.error) {
              reject(response.data);
          } else {
              resolve(response.data);
          }
        });
      });
  }

  makePrivateDelete(url, params)
  {
    let options = {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Authorization': 'Bearer ' + this._access_token,
      },
      body: JSON.stringify(params)
    };
    
    return fetch(url, options)
    .then((response) => {return response.json()})
    .then((response)=>{
      return new Promise((resolve, reject) => {
        if(response.error){
          reject(response.data);
        }else{
          resolve(response.data);
        }
      });
    });
  }
}



const Auth = new AuthClass();

export default Auth;
